import React from 'react'

const GoogleMap = ({ url }) => {
  return (
    <div class="relative w-full h-96">
      <iframe class="absolute top-0 left-0 w-full h-full"
          src={url}
          frameborder="0" style={{ border: 0}} allowfullscreen="" aria-hidden="false" tabindex="0" loading="lazy">
      </iframe>
    </div>
  )
}

export default GoogleMap